import { Stack } from '@mui/material';
import { styled } from '@mui/system';

export const Container = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: string }>(({ theme, status }) => {
  let color;
  let backgroundColor;

  // Accept both the raw (`PARTIALLY_AVAILABLE`) and the display-normalized
  // (`PARTIALLY AVAILABLE`, as the booking view-model emits) forms so the chip
  // colours correctly regardless of which a caller passes.
  const normalizedStatus = status?.toUpperCase().replaceAll(' ', '_');

  let padding: string;

  switch (normalizedStatus) {
    case 'AVAILABLE':
    case 'APPROVED':
    case 'ACTIVE':
    case 'PUBLISHED':
    case 'CONFIRMED':
    case 'DONE':
    case 'COMPLETED':
      color = theme.palette.green[700];
      backgroundColor = theme.palette.green[100];
      padding = '4px 8px';
      break;
    case 'BOOKED':
    case 'IN_PROGRESS':
    case 'IN_REVIEW':
    case 'SHIPPED':
    case 'REJECTED':
    case 'CANCELLED':
    case 'BLOCKED':
      color = theme.palette.red[500];
      backgroundColor = theme.palette.red[100];
      padding = '2px 4px';
      break;
    case 'DRAFT':
    case 'SPACE_DRAFT':
    case 'ADVERTISING_PACKAGE_DRAFT':
    case 'NA':
    case 'PARTIALLY_AVAILABLE':
    case 'PRINT_PROOF_REQUIRED':
    case 'WILL_CLOSE':
    case 'CLOSED':
      color = theme.palette.orange[600];
      backgroundColor = theme.palette.orange[100];
      padding = '2px 4px';
      break;
    default:
      color = theme.palette.grey[700];
      backgroundColor = theme.palette.grey[100];
      padding = '2px 4px';
      break;
  }

  return {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor,
    borderRadius: '10px',
    padding,
    gap: '4px',

    '& > p': {
      margin: 0,
      color,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '160%',
    },

    '& > div': {
      backgroundColor: color,
    },
  };
});
